var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpClient } from '@telus/core-fetch';
const legalsClient = new HttpClient();
/**
 * Fetches the legal content corresponding to an array of slugs.
 *
 * @param url URL of the legals backend.
 * @param slugs Array of slugs we want to fetch.
 * @param locale Locale to fetch legals in.
 * @returns An array of LegalItem corresponding to the slugs param.
 */
export default function fetchLegals(url, slugs, locale, preview) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!slugs.length) {
            return [];
        }
        try {
            return yield legalsClient.get(url, {
                searchParams: {
                    slugs: slugs.join(','),
                    locale,
                    preview: preview ? 'true' : 'false'
                }
            });
        }
        catch (err) {
            console.error(err);
            return [];
        }
    });
}
